import React from 'react'
import { Skeleton } from 'src/component/ui/skeleton'

export const ProfileYourAwardsCardSkeleton = (): React.ReactElement => {
  return (
    <Skeleton className="p-5 px-[15px] rounded-md border border-bright-grey h-[255px] flex flex-col justify-between bg-tertiary-grey" />
  )
}
